import UsersTable from './components/UsersTable';
import Widget from 'components/widget/Widget';
import { MdOutlineGeneratingTokens } from 'react-icons/md';
import { useTokensStore } from 'views/store/useTokensStore';

const TokensByPurchase = () => {
  const { totalTokens } = useTokensStore();

  return (
    <div>
      <div className="mt-3 w-full flex md:flex-row gap-4 items-center">
        <div className="w-fit">
          <Widget
            icon={<MdOutlineGeneratingTokens className="h-7 w-7" />}
            title={'Total tokens'}
            subtitle={!totalTokens ? 'Loading...' : totalTokens}
          />
        </div>
      </div>
      <div className="mt-5 grid grid-cols-1 gap-5">
        <div className="w-full">
          <UsersTable />
        </div>
      </div>
    </div>
  );
};

export default TokensByPurchase;
